class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // Add hover event listeners for the main menu
    this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.close.bind(this));

    // Handle submenus
    const submenus = this.mainDetailsToggle.querySelectorAll('details');
    submenus.forEach((submenu) => {
      submenu.addEventListener('mouseenter', this.openSubmenu.bind(this, submenu));
      submenu.addEventListener('mouseleave', this.closeSubmenu.bind(this, submenu));
    });

    console.log('Menu and submenu hover initialized');
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);

    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.cancel());
  }

  openSubmenu(submenu) {
    submenu.setAttribute('open', true);
    submenu.querySelector('summary').setAttribute('aria-expanded', true);

    const submenuContent = submenu.querySelector('summary').nextElementSibling;
    const submenuAnimations = submenuContent.getAnimations();
    submenuAnimations.forEach((animation) => animation.play());
  }

  closeSubmenu(submenu) {
    submenu.removeAttribute('open');
    submenu.querySelector('summary').setAttribute('aria-expanded', false);

    const submenuContent = submenu.querySelector('summary').nextElementSibling;
    const submenuAnimations = submenuContent.getAnimations();
    submenuAnimations.forEach((animation) => animation.cancel());
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  open() {
    super.open();

    if (!this.header) return;
    this.header.preventHide = true;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    super.close();

    if (this.header) {
      this.header.preventHide = false;
    }
  }
}

customElements.define('header-menu', HeaderMenu);
